export default [
    {
        value: 'ar',
        text: 'Arabic',
    },
    {
        value: 'bg',
        text: 'Bulgarian',
    },
    {
        value: 'ch',
        text: 'Chinese',
    },
    {
        value: 'da',
        text: 'Danish',
    },
    {
        value: 'de',
        text: 'German',
    },
    {
        value: 'el',
        text: 'Greek',
    },
    {
        value: 'en',
        text: 'English',
    },
    {
        value: 'es',
        text: 'Spanish',
    },
    {
        value: 'et',
        text: 'Estonian',
    },
    {
        value: 'fi',
        text: 'Finnish',
    },
    {
        value: 'fr',
        text: 'French',
    },
    {
        value: 'hu',
        text: 'Hungarian',
    },
    {
        value: 'it',
        text: 'Italian',
    },
    {
        value: 'ja',
        text: 'Japanese',
    },
    {
        value: 'nl',
        text: 'Dutch',
    },
    {
        value: 'pl',
        text: 'Polish',
    },
    {
        value: 'pt',
        text: 'Portuguese',
    },
    {
        value: 'ro',
        text: 'Romanian',
    },
    {
        value: 'ru',
        text: 'Russian',
    },
    {
        value: 'sr',
        text: 'Serbian',
    },
    {
        value: 'sv',
        text: 'Swedish',
    },
    {
        value: 'tr',
        text: 'Turkish',
    },

];
